import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import Group from 'components/utils/Group'
import React from 'react'
import PromotionLabel from 'LuxKit/Label/PromotionLabel'

interface Props {
  benefit: App.LoyaltyBenefit
  tier: App.LoyaltyTier
  title: string
  icon: React.ReactElement
  promotion?: App.LabFeatureFlagResult
}

const getBenefitBadgeLabel = (benefit: App.LoyaltyBenefit): string | undefined => {
  const { value, unlimited, remaining } = benefit

  if (value?.unit === 'PERCENTAGE') {
    return `${value.amount}%`
  }

  if (unlimited) {
    return 'Unlimited'
  }

  if (remaining === 0) {
    return 'Redeemed'
  }

  if (typeof remaining === 'number') {
    return `${remaining}x`
  }

  return undefined
}

function AccountDrawerBenefitHighlightItem(props: Props) {
  const { benefit, tier, title, icon, promotion } = props

  const badgeLabel = getBenefitBadgeLabel(benefit)

  return (
    <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="center">
      <BodyTextBlock variant="small" startIcon={icon}>
        {title}
      </BodyTextBlock>
      <Group direction="horizontal" verticalAlign="center" gap={12}>
        {promotion?.enabled && <PromotionLabel variant="premium">New</PromotionLabel>}
        <LoyaltyTierLabel kind="secondary" tier={tier}>
          {badgeLabel && <>{badgeLabel}</>}
        </LoyaltyTierLabel>
      </Group>
    </Group>
  )
}

export default AccountDrawerBenefitHighlightItem
